import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";
import axios from 'axios';
import MockAdapter from 'axios-mock-adapter';
import { FeaturesService } from '@services/features';
import { aesDecryption, aesEncryption, ConstantsUtil, encryptDecrypt, tokenCreation, tokenCreationE2EE } from '@utils';
import { ErrorInterceptor, FakeBackendInterceptor, LoaderInterceptor } from '@interceptors';
import { Feature } from '@enums';
var stackRequest = new Map();
export var http = axios.create({
  baseURL: process.env.baseUrl,
  headers: {
    'Content-type': 'application/json'
  },
  errorRedirect: true
});

if (FeaturesService.available(Feature.MockAPI)) {
  var mockAdapter = new MockAdapter(http, {
    delayResponse: 1000
  });
  FakeBackendInterceptor(mockAdapter);
}

http.interceptors.request.use(function (request) {
  try {
    var token;
    var cypherText = sessionStorage.getItem(ConstantsUtil.localStorage.mlCypherText);

    if (FeaturesService.available(Feature.E2EE)) {
      var id = sessionStorage.getItem('id');
      var entropy = sessionStorage.getItem(ConstantsUtil.localStorage.entropy);

      if (id && entropy) {
        token = tokenCreationE2EE();
      }
    } else {
      token = tokenCreation();
    }

    if (request && request.headers && sessionStorage.getItem(ConstantsUtil.localStorage.sessionId)) {
      request.headers['Session-Id'] = sessionStorage.getItem(ConstantsUtil.localStorage.sessionId) || false;
    }

    if (request && request.headers && token) {
      request.headers.Authorization = token ? "Bearer ".concat(token) : false;
    }

    if (request && request.headers && cypherText && !token) {
      request.headers.ESS = cypherText || false;
    }

    return request;
  } catch (error) {
    return request;
  }
});
http.interceptors.request.use(function (request) {
  var url = request.url || 'error';
  var controller = request.abortController || new AbortController();

  if (!request.abortController) {
    request.signal = controller.signal;
  }

  if (stackRequest.has(url)) {
    var _stackRequest$get;

    (_stackRequest$get = stackRequest.get(url)) === null || _stackRequest$get === void 0 ? void 0 : _stackRequest$get.abort();
    stackRequest["delete"](url);
  }

  stackRequest.set(url, controller);
  return request;
});
http.interceptors.response.use(function (response) {
  var url = response.config.url || 'error';

  if (stackRequest.has(url)) {
    stackRequest["delete"](url);
  }

  return response;
});
http.interceptors.request.use(function (request) {
  if (request.prefixURL) {
    var baseURL = request.baseURL || '';
    request.baseURL = "".concat(baseURL).concat(request.prefixURL);
  }

  return request;
});
http.interceptors.request.use(function (request) {
  return LoaderInterceptor({
    request: request
  });
}, function (error) {
  return LoaderInterceptor({
    error: error
  });
});
http.interceptors.response.use(function (response) {
  return LoaderInterceptor({
    response: response
  });
}, function (error) {
  return LoaderInterceptor({
    error: error
  });
});
http.interceptors.request.use(function (request) {
  return request;
}, ErrorInterceptor);
http.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  var _error$config;

  var url = (error === null || error === void 0 ? void 0 : (_error$config = error.config) === null || _error$config === void 0 ? void 0 : _error$config.url) || 'error';

  if (stackRequest.has(url)) {
    stackRequest["delete"](url);
  }

  if (axios.isCancel(error)) {
    return;
  }

  return ErrorInterceptor(error);
});
http.interceptors.response.use(function (response) {
  if (typeof response.data === 'string' && response.data.length > 0) {
    var decryptedData;

    if (FeaturesService.available(Feature.E2EE)) {
      var ct = sessionStorage.getItem(ConstantsUtil.localStorage.mlSecret);
      decryptedData = aesDecryption(Buffer.from(response.data, 'base64'), Buffer.from(ct || '', 'base64'));
    } else {
      var password = sessionStorage.getItem(ConstantsUtil.localStorage.randomString);
      var encryptedSixKey = sessionStorage.getItem(ConstantsUtil.localStorage.sixKey);
      var sixKey = encryptDecrypt(encryptedSixKey || '', password || '');
      decryptedData = aesDecryption(Buffer.from(response.data, 'base64'), Buffer.from(sixKey, 'base64'));
    } // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/ban-ts-comment
    // @ts-ignore
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment


    response.data = JSON.parse(decryptedData.toString('utf-8'));
    return response;
  }

  return response;
});
/**
 * Api service.
 *
 * @author Ihar Kazlouski
 * @class ApiServiceClass
 * @category Services
 */

var ApiServiceClass = /*#__PURE__*/function () {
  function ApiServiceClass() {
    _classCallCheck(this, ApiServiceClass);
  }

  _createClass(ApiServiceClass, [{
    key: "bodyEncryption",
    value: function bodyEncryption(body) {
      var password = sessionStorage.getItem(ConstantsUtil.localStorage.randomString);
      var encryptedSixKey = sessionStorage.getItem(ConstantsUtil.localStorage.sixKey);
      var sixKey = encryptDecrypt(encryptedSixKey || '', password || '');

      if (FeaturesService.available(Feature.E2EE)) {
        var ct = sessionStorage.getItem(ConstantsUtil.localStorage.mlSecret);
        return aesEncryption(Buffer.from(JSON.stringify(body), 'utf-8'), Buffer.from(ct || '', 'base64'));
      }

      return aesEncryption(Buffer.from(JSON.stringify(body), 'utf-8'), Buffer.from(sixKey, 'base64'));
    }
    /**
     * Api get function.
     *
     * @author Ihar Kazlouski
     * @param {string} path path.
     * @param {AxiosRequestConfig} props AxiosRequestConfig props.
     * @return {Promise<ApiError | AxiosResponse>} data promise.
     */

  }, {
    key: "apiGet",
    value: function () {
      var _apiGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(path, props) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return http.get(path, props);

              case 2:
                return _context.abrupt("return", _context.sent);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function apiGet(_x, _x2) {
        return _apiGet.apply(this, arguments);
      }

      return apiGet;
    }()
    /**
     * Api post function.
     *
     * @author Ihar Kazlouski
     * @param {Record<string, unknown> | FormData | T} body body.
     * @param {AxiosRequestConfig} props AxiosRequestConfig props.
     * @return {Promise<ApiError | AxiosResponse>} data promise.
     */

  }, {
    key: "apiPost",
    value: function () {
      var _apiPost = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(path, body, props) {
        var encrypted,
            json,
            _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                encrypted = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : true;

                if (encrypted && FeaturesService.available(Feature.Encryption)) {
                  json = {
                    body: this.bodyEncryption(body)
                  };
                } else {
                  json = body;
                }

                _context2.next = 4;
                return http.post(path, json, props);

              case 4:
                return _context2.abrupt("return", _context2.sent);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function apiPost(_x3, _x4, _x5) {
        return _apiPost.apply(this, arguments);
      }

      return apiPost;
    }()
    /**
     * Api put function.
     *
     * @author Ihar Kazlouski
     * @param {Record<string, unknown> | FormData | T} body body.
     * @param {AxiosRequestConfig} props AxiosRequestConfig props.
     * @return {Promise<ApiError | AxiosResponse>} data promise.
     */

  }, {
    key: "apiPut",
    value: function () {
      var _apiPut = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(path, body, props) {
        var encrypted,
            json,
            _args3 = arguments;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                encrypted = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : true;

                if (encrypted && FeaturesService.available(Feature.Encryption)) {
                  json = {
                    body: this.bodyEncryption(body)
                  };
                } else {
                  json = body;
                }

                _context3.next = 4;
                return http.put(path, json, props);

              case 4:
                return _context3.abrupt("return", _context3.sent);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function apiPut(_x6, _x7, _x8) {
        return _apiPut.apply(this, arguments);
      }

      return apiPut;
    }()
    /**
     * Api patch function.
     *
     * @author Ruslan Kolesov
     * @param {Record<string, unknown> | FormData | T} body body.
     * @param {AxiosRequestConfig} props AxiosRequestConfig props.
     * @return {Promise<ApiError | AxiosResponse>} data promise.
     */

  }, {
    key: "apiPatch",
    value: function () {
      var _apiPatch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(path, body, props) {
        var encrypted,
            json,
            _args4 = arguments;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                encrypted = _args4.length > 3 && _args4[3] !== undefined ? _args4[3] : true;

                if (encrypted && FeaturesService.available(Feature.Encryption)) {
                  json = {
                    body: this.bodyEncryption(body)
                  };
                } else {
                  json = body;
                }

                _context4.next = 4;
                return http.patch(path, json, props);

              case 4:
                return _context4.abrupt("return", _context4.sent);

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function apiPatch(_x9, _x10, _x11) {
        return _apiPatch.apply(this, arguments);
      }

      return apiPatch;
    }()
    /**
     * Api delete function.
     *
     * @author Ihar Kazlouski
     * @param {Record<string, unknown> | FormData | T} body body.
     * @param {AxiosRequestConfig} props AxiosRequestConfig props.
     * @return {Promise<ApiError | AxiosResponse>} data promise.
     */

  }, {
    key: "apiDelete",
    value: function () {
      var _apiDelete = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(path, body, props) {
        var encrypted,
            json,
            _args5 = arguments;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                encrypted = _args5.length > 3 && _args5[3] !== undefined ? _args5[3] : true;

                if (encrypted && FeaturesService.available(Feature.Encryption)) {
                  json = {
                    body: this.bodyEncryption(body || {})
                  };
                } else {
                  json = body;
                }

                _context5.next = 4;
                return http["delete"](path, _objectSpread(_objectSpread({}, body && {
                  data: json
                }), props));

              case 4:
                return _context5.abrupt("return", _context5.sent);

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function apiDelete(_x12, _x13, _x14) {
        return _apiDelete.apply(this, arguments);
      }

      return apiDelete;
    }()
  }]);

  return ApiServiceClass;
}();

var ApiService = new ApiServiceClass();
export { ApiService };